<div class="ws-popup-header">
  <div>{{ 'payments.list.filtersTitle' | translate }}</div>
  <div class="actions">
    <button (click)="closeClicked()" mat-icon-button type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body filter-wrapper">
    <!-- Not a <form>: ws-selector/ws-button would submit and refresh the page (WS-4237). -->
    <div class="form-container" [formGroup]="form">
      <div class="field-wrapper">
        <label for="customerName">{{ 'payments.list.filterCustomerName' | translate }}</label>
        <div class="input-wrapper">
          <input id="customerName" formControlName="customerName" type="text" matInput
            [placeholder]="'payments.list.filterCustomerName' | translate" />
        </div>
      </div>

      <div class="field-wrapper">
        <label for="customerEmail">{{ 'payments.list.filterCustomerEmail' | translate }}</label>
        <div class="input-wrapper">
          <input id="customerEmail" formControlName="customerEmail" type="email" matInput
            [placeholder]="'payments.list.filterCustomerEmail' | translate" />
        </div>
      </div>

      <div class="field-wrapper">
        <label for="saleId">{{ 'payments.list.filterSaleId' | translate }}</label>
        <div class="input-wrapper">
          <input id="saleId" formControlName="saleId" type="text" matInput placeholder="UUID" />
        </div>
      </div>

      <div class="field-wrapper">
        <label>{{ 'payments.list.filterStatus' | translate }}</label>
        <div class="input-wrapper">
          <ws-selector [options]="statusOptions" [selected]="form.get('status')?.value"
            (selectedChange)="onSelectorChange('status', $event)" [formatter]="optionNameFormatter"
            [placeholder]="'Select option' | translate">
          </ws-selector>
        </div>
      </div>

      <div class="field-wrapper">
        <label>{{ 'payments.list.filterMode' | translate }}</label>
        <div class="input-wrapper">
          <ws-selector [options]="modeOptions" [selected]="form.get('mode')?.value"
            (selectedChange)="onSelectorChange('mode', $event)" [formatter]="optionNameFormatter"
            [placeholder]="'Select option' | translate">
          </ws-selector>
        </div>
      </div>

      <div class="field-wrapper">
        <label>{{ 'payments.list.filterOrigin' | translate }}</label>
        <div class="input-wrapper">
          <ws-selector [options]="originOptions" [selected]="form.get('origin')?.value"
            (selectedChange)="onSelectorChange('origin', $event)" [formatter]="optionNameFormatter"
            [placeholder]="'Select option' | translate">
          </ws-selector>
        </div>
      </div>

      <div class="field-wrapper">
        <label>{{ 'Total' | translate }}</label>
        <div class="input-wrapper">
          <div class="currency-inputs">
            <input id="amountMin" formControlName="amountMin" type="number" matInput
              [placeholder]="'Min' | translate" />
            <input id="amountMax" formControlName="amountMax" type="number" matInput
              [placeholder]="'Max' | translate" />
          </div>
        </div>
      </div>

      <div class="field-wrapper">
        <label>{{ 'Date' | translate }}</label>
        <div class="input-wrapper">
          <div class="date-range-inputs">
            <div class="date-picker-input">
              <input (focus)="pickerFrom.open()" formControlName="dateFrom" [matDatepicker]="pickerFrom" matInput
                [placeholder]="'payments.list.filterDateFrom' | translate" />
              <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
              <mat-datepicker #pickerFrom></mat-datepicker>
            </div>
            <div class="date-picker-input">
              <input (focus)="pickerTo.open()" formControlName="dateTo" [matDatepicker]="pickerTo" matInput
                [placeholder]="'payments.list.filterDateTo' | translate" />
              <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
              <mat-datepicker #pickerTo></mat-datepicker>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="ws-popup-footer">
    <span></span>
    <div class="actions-wrapper">
      <ws-button [callToActionType]="'danger'" type="button" (click)="resetClicked()" style="margin-right: 10px">
        {{ 'payments.list.filterBtnRemove' | translate }}
      </ws-button>
      <ws-button [callToActionType]="'primary'" type="button" (click)="submitClicked()">
        {{ 'payments.list.filterBtnSearch' | translate }}
      </ws-button>
    </div>
  </div>
</div>